import { render, staticRenderFns } from "./osConfirmacao.vue?vue&type=template&id=488db004&scoped=true"
import script from "./osConfirmacao.vue?vue&type=script&lang=js"
export * from "./osConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./osConfirmacao.vue?vue&type=style&index=0&id=488db004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488db004",
  null
  
)

export default component.exports